module.exports = __webpack_public_path__ + "static/img/20190911065538.a285ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/20190911065538.png
// module id = Oq2Q
// module chunks = 1